var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { offerList as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { useOfferColumns } from '../../../hooks/useColumns';
import { decamelize } from '../../../utils/camelize';
import MaterialTable from '../../MaterialTable';
import EditField from './EditField';
import SampleOrderStocks from './SampleOrderStocks';
import { useNavigate } from 'react-router-dom';
import { AuctionIcon, ExclusiveIcon as ExclusiveIconOrigianl, } from '../../atoms/Icons';
import ExclusiveLotRoasterSelectDialog from './ExclusiveLotRoasterSelectDialog';
import CuppingCommentsDialog from './CuppingComments/CuppingCommentsDialog';
import { Comment as CommentIcon } from '@mui/icons-material';
import { green } from '@mui/material/colors';
var ExclusiveIcon = styled(ExclusiveIconOrigianl)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (props) { return props.$bgColor; });
var CELL_ERROR_STYLE = { color: 'red' };
var colorRedIf = function (column, condition) { return (__assign(__assign({}, column), { cellStyle: function (_, offer) {
        if (offer) {
            return condition(offer[column.field], offer)
                ? CELL_ERROR_STYLE
                : {};
        }
        else {
            return {};
        }
    } })); };
var any = function () {
    var conditions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        conditions[_i] = arguments[_i];
    }
    return function (value, offer) {
        return conditions.some(function (condition) { return condition(value, offer); });
    };
};
var valueIsEmpty = function (value) { return !value; };
var valueIsNegative = function (value) { return value < 0; };
var minOrderIsNotMultipleOfBagSize = function (_, offer) {
    if ([offer.minOrder, offer.bagSize].some(function (value) { return !value; })) {
        return true;
    }
    return ((parseFloat(offer.minOrder) * 100) % (parseFloat(offer.bagSize) * 100) !== 0);
};
var fobPriceDoesNotEqualBreakdownSums = function (_, offer) {
    if ([
        offer.breakdownFarm,
        offer.breakdownMill,
        offer.breakdownProducer,
        offer.fobPrice,
    ].some(function (value) { return !value; })) {
        return true;
    }
    var breakdownSum = parseFloat(offer.breakdownFarm) +
        parseFloat(offer.breakdownMill) +
        parseFloat(offer.breakdownProducer);
    return breakdownSum.toFixed(2) !== parseFloat(offer.fobPrice).toFixed(2);
};
var OffersTable = function (_a) {
    var offerList = _a.offerList, offers = _a.offers, onChange = _a.onChange;
    var t = useTranslation().t;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var createOffer = useRequest(api.createOffer);
    var _c = React.useState(), editingOffer = _c[0], setEditingOffer = _c[1];
    var _d = React.useState(), cuppingCommentOffer = _d[0], setCuppingCommentOffer = _d[1];
    var updateOffer = useRequest(api.updateOffer);
    var deleteOffer = useRequest(api.deleteOffer);
    var navigate = useNavigate();
    var OfferColumns = useOfferColumns();
    var columns = React.useMemo(function () { return [
        colorRedIf(OfferColumns.lotNumber, valueIsEmpty),
        OfferColumns.orderType,
        OfferColumns.lotRef,
        OfferColumns.bagmark,
        OfferColumns.originType,
        colorRedIf(OfferColumns.farm, valueIsEmpty),
        OfferColumns.producerName,
        colorRedIf(OfferColumns.region, valueIsEmpty),
        colorRedIf(OfferColumns.district, valueIsEmpty),
        OfferColumns.altitude,
        OfferColumns.farmSize,
        colorRedIf(OfferColumns.variety, valueIsEmpty),
        OfferColumns.grade,
        colorRedIf(OfferColumns.processing, valueIsEmpty),
        OfferColumns.processingMethod,
        OfferColumns.harvestYear,
        OfferColumns.harvestMonth,
        colorRedIf(OfferColumns.minOrder, any(valueIsEmpty, minOrderIsNotMultipleOfBagSize)),
        OfferColumns.remainingQuantity,
        OfferColumns.purchaseLimit,
        colorRedIf(OfferColumns.fobPrice, any(valueIsEmpty, valueIsNegative)),
        colorRedIf(OfferColumns.bagSize, any(valueIsEmpty, minOrderIsNotMultipleOfBagSize)),
        OfferColumns.package,
        colorRedIf(OfferColumns.breakdownFarm, any(valueIsEmpty, fobPriceDoesNotEqualBreakdownSums)),
        colorRedIf(OfferColumns.breakdownMill, any(valueIsEmpty, fobPriceDoesNotEqualBreakdownSums)),
        colorRedIf(OfferColumns.breakdownProducer, any(valueIsEmpty, fobPriceDoesNotEqualBreakdownSums)),
        OfferColumns.typicaHandlingRates,
        OfferColumns.producerComment,
        OfferColumns.narrativeUrls,
        OfferColumns.downloadLink,
        OfferColumns.note,
    ]; }, [OfferColumns]);
    var createOfferRequest = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextOffers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, createOffer(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    nextOffers = [];
                    offers.forEach(function (o) {
                        nextOffers.push(o);
                    });
                    nextOffers.push(response);
                    onChange(nextOffers);
                    return [2 /*return*/];
            }
        });
    }); }, [createOffer, offers, onChange]);
    var updateOfferRequest = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextOffers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, updateOffer(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    nextOffers = [];
                    offers.forEach(function (o) {
                        if (data.id === o.id) {
                            nextOffers.push(response);
                        }
                        else {
                            nextOffers.push(o);
                        }
                    });
                    onChange(nextOffers);
                    return [2 /*return*/];
            }
        });
    }); }, [updateOffer, offers, onChange]);
    var deleteOfferRequest = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, nextOffers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, deleteOffer(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    nextOffers = offers.filter(function (offer) { return data.id !== offer.id; });
                    onChange(nextOffers);
                    return [2 /*return*/];
            }
        });
    }); }, [deleteOffer, offers, onChange]);
    var handleRowAdd = React.useCallback(function (offer) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        offer_list_id: offerList.id,
                        offer: Object.entries(offer).reduce(function (prev, _a) {
                            var field = _a[0], value = _a[1];
                            if (field === 'remainingQuantity') {
                                prev['quantity'] = value;
                            }
                            else {
                                prev[decamelize(field)] = value;
                            }
                            return prev;
                        }, {}),
                    };
                    return [4 /*yield*/, createOfferRequest(data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [offerList, createOfferRequest]);
    var handleRowDelete = React.useCallback(function (offer) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        id: offer.id,
                        offer_list_id: offerList.id,
                    };
                    return [4 /*yield*/, deleteOfferRequest(data)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [offerList, deleteOfferRequest]);
    var handleCellUpdate = React.useCallback(function (newValue, oldValue, offer, columnDef) { return __awaiter(void 0, void 0, void 0, function () {
        var field, value, data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (newValue === oldValue || !columnDef.field)
                        return [2 /*return*/];
                    field = decamelize(columnDef.field);
                    value = newValue;
                    if (field === 'remaining_quantity') {
                        field = "".concat(field.replace('remaining_', ''), "_delta");
                        value = parseInt(newValue) - parseInt(oldValue);
                    }
                    data = {
                        id: offer.id,
                        offer_list_id: offerList.id,
                        offer: (_a = {}, _a[field] = value, _a),
                    };
                    return [4 /*yield*/, updateOfferRequest(data)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [offerList, updateOfferRequest]);
    // publishedCountriesが更新された時に、offerも更新してdetailpanelを更新するようにしたいので
    // 以下のようなdataを作る
    var offersWithPublishedCountries = React.useMemo(function () {
        return offers.map(function (offer) {
            offer.offerList.offers = []; // For 「Uncaught TypeError: cyclic object value」
            return __assign(__assign({}, offer), { publishedCountries: offerList.publishedCountries });
        });
    }, [offers, offerList.publishedCountries]);
    var detailPanel = React.useCallback(function (_a) {
        var rowData = _a.rowData;
        return (React.createElement("div", null,
            React.createElement(SampleOrderStocks, { offer: rowData, isOfferListActive: rowData.offerList.status === 'active' })));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(MaterialTable, { title: t('offers'), model: "offer", emptyValue: "(blank)", isLoading: loading, detailPanel: detailPanel, columns: columns, actions: [
                function (offer) { return ({
                    icon: function () { return React.createElement(CommentIcon, null); },
                    tooltip: 'Cupping comments',
                    onClick: function () { return setCuppingCommentOffer(offer); },
                }); },
                function (offer) { return ({
                    icon: function () { return React.createElement(AuctionIcon, null); },
                    hidden: offer.orderType !== 'auction',
                    tooltip: 'Auction',
                    onClick: function () {
                        return navigate("/admin/offer_lists/".concat(offerList.id, "/auctions/").concat(offer.id));
                    },
                }); },
                function (offer) { return ({
                    icon: function () {
                        var _a;
                        return (React.createElement(ExclusiveIcon, { "$bgColor": offer.exclusiveLots && ((_a = offer.exclusiveLots) === null || _a === void 0 ? void 0 : _a.length) >= 1
                                ? '#bdbdbd'
                                : 'red' }));
                    },
                    hidden: offer.orderType !== 'basic',
                    tooltip: 'Exclusive',
                    onClick: function (_event, offer) { return setEditingOffer(offer); },
                }); },
            ], data: offersWithPublishedCountries, cellEditable: {
                onCellEditApproved: handleCellUpdate,
                isCellEditable: function (rowData, columnDef) {
                    var _a;
                    if (columnDef.field === 'orderType' &&
                        (((_a = rowData.exclusiveLots) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0)
                        return false;
                    return true;
                },
                cellStyle: { color: 'black' }, // cancel out error color
            }, editable: ['draft', 'preparing'].includes(offerList.status)
                ? {
                    onRowAdd: handleRowAdd,
                    onRowDelete: handleRowDelete,
                }
                : {}, components: {
                EditField: EditField,
            }, options: {
                maxBodyHeight: 'calc(100vh - 60px)',
                actionsColumnIndex: 0,
                rowStyle: function (_a) {
                    var isAdditional = _a.isAdditional;
                    return ({
                        backgroundColor: isAdditional ? green[50] : '',
                    });
                },
            } }),
        React.createElement(ExclusiveLotRoasterSelectDialog, { open: Boolean(editingOffer), onClose: function () { return setEditingOffer(undefined); }, offerList: offerList, offer: editingOffer, exclusiveLots: editingOffer === null || editingOffer === void 0 ? void 0 : editingOffer.exclusiveLots, onChange: function (exclusiveLots, remainingQuantity) {
                if (!editingOffer)
                    return;
                var nextOffers = [];
                offers.forEach(function (o) {
                    if (editingOffer.id === o.id) {
                        editingOffer.exclusiveLots = exclusiveLots;
                        editingOffer.remainingQuantity = remainingQuantity;
                        nextOffers.push(editingOffer);
                    }
                    else {
                        nextOffers.push(o);
                    }
                });
                onChange(nextOffers);
            } }),
        React.createElement(CuppingCommentsDialog, { offer: cuppingCommentOffer, onClose: function () { return setCuppingCommentOffer(undefined); }, onChangeOffer: function (offer) { return setCuppingCommentOffer(offer); } })));
};
export default OffersTable;
var templateObject_1;
